import { IBaseControls } from './index';
import { BaseCameraControls } from './BaseCameraControls';
import { CameraAutoZoom } from '@fillip/api';
import { Box3 } from 'three';
import * as Location3D from '@/utils/location3D';

export class AutoZoomControls
  extends BaseCameraControls
  implements IBaseControls
{
  initialize(): void {
    super.initialize();
  }

  updateCamera(
    sceneCamera: CameraAutoZoom,
    sceneBoundingBox: Box3,
    hasParentChanged: boolean,
  ) {
    super.updateCamera(sceneCamera, sceneBoundingBox, hasParentChanged);
  }

  checkCameraPosition() {
    if (Location3D.hasBox3Size(this.sceneBoundingBox)) {
      this.zoomToFit(this.sceneBoundingBox);
    }
  }
}
